const HEADER_MENU_HEIGHT = 64;
const TRIGGER_ANIMATION_BANNER = 30;

export { HEADER_MENU_HEIGHT, TRIGGER_ANIMATION_BANNER };
